import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const CURRENT_DATE = dayjs();
const CURRENT_YEAR = new Date().getFullYear();

// ===== Questionnaire =====
const createQuestionnaireDates = (monthAndDay: string, timezoneName: string) => {
  const closeDate = dayjs.tz(`${CURRENT_YEAR}-${monthAndDay} 23:59:00`, timezoneName);
  // Give the college procrastinators until 1:30am the following day.
  const disabledDate = closeDate.add(1, 'day').startOf('day').add(90, 'minutes');

  return {
    closeDate: closeDate.local(),
    disabledDate: disabledDate.local(),
  };
};

const QUESTIONNAIRE_DATES_SINGAPORE = createQuestionnaireDates('09-20', 'Asia/Singapore');
export const QUESTIONNAIRE_CLOSE_DATE_SINGAPORE = QUESTIONNAIRE_DATES_SINGAPORE.closeDate;
export const QUESTIONNAIRE_DISABLED_DATE_SINGAPORE = QUESTIONNAIRE_DATES_SINGAPORE.disabledDate;

const QUESTIONNAIRE_DATES_GLOBAL = createQuestionnaireDates('02-12', 'America/New_York');
export const QUESTIONNAIRE_CLOSE_DATE_GLOBAL = QUESTIONNAIRE_DATES_GLOBAL.closeDate;
export const QUESTIONNAIRE_DISABLED_DATE_GLOBAL = QUESTIONNAIRE_DATES_GLOBAL.disabledDate;

// ===== Launch =====
// Was pushed one day back in 2025 for some time.
export const LAUNCH_DATE_SINGAPORE = dayjs(`August 30 ${CURRENT_YEAR} 20:00:00 UTC+8`)
  .tz('Australia/Perth')
  .local();
const CURRENT_VALENTINES = dayjs(`Februrary 14, ${CURRENT_YEAR}, 20:00:00 UTC-5`)
  .tz('America/Los_Angeles')
  .local();
const UPCOMING_GLOBAL_LAUNCH_YEAR = CURRENT_DATE.isAfter(CURRENT_VALENTINES)
  ? CURRENT_YEAR + 1
  : CURRENT_YEAR;
export const LAUNCH_DATE_GLOBAL = dayjs(
  `January 26, ${UPCOMING_GLOBAL_LAUNCH_YEAR}, 00:00:00 UTC-5`,
)
  .tz('America/Los_Angeles')
  .local();

// ===== Match Results =====
export const MATCH_RESULTS_DATE_SINGAPORE = '22nd September';
export const MATCH_RESULTS_DATE_GLOBAL = '14th February (ET)';
